import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

/**
 * Created by Jerker Nord on 2022-11-11.
 */

export class BenjiKIVSuperFreeSpinIntroRunner implements SimplePresentation {

    public shouldRun():boolean {
        return (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN);
    }

    public start(controller:SimplePresentationRunnerController):void {
        BenjiKIV.superFsIntroView.showSFSIntro(() => BenjiKIVSuperFreeSpinIntroRunner.superFsIntroClosedCallback(controller));
    }

    private static superFsIntroClosedCallback(controller:SimplePresentationRunnerController):void {
        controller.finish();
    }
}